var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplistSingleImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3251_11892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5403 4.86133H7.14029C5.69458 4.86133 4.51172 6.04064 4.51172 7.48202V25.8268C4.51172 27.2682 5.69458 28.4475 7.14029 28.4475H25.5403C26.986 28.4475 28.1689 27.2682 28.1689 25.8268V7.48202C28.1689 6.04064 26.986 4.86133 25.5403 4.86133ZM11.0831 23.2062C10.3603 23.2062 9.76886 22.6165 9.76886 21.8958V17.9648C9.76886 17.2441 10.3603 16.6544 11.0831 16.6544C11.806 16.6544 12.3974 17.2441 12.3974 17.9648V21.8958C12.3974 22.6165 11.806 23.2062 11.0831 23.2062ZM16.3403 23.2062C15.6174 23.2062 15.026 22.6165 15.026 21.8958V20.5855C15.026 19.8648 15.6174 19.2751 16.3403 19.2751C17.0631 19.2751 17.6546 19.8648 17.6546 20.5855V21.8958C17.6546 22.6165 17.0631 23.2062 16.3403 23.2062ZM16.3403 16.6544C15.6174 16.6544 15.026 16.0648 15.026 15.3441C15.026 14.6234 15.6174 14.0337 16.3403 14.0337C17.0631 14.0337 17.6546 14.6234 17.6546 15.3441C17.6546 16.0648 17.0631 16.6544 16.3403 16.6544ZM21.5974 23.2062C20.8746 23.2062 20.2831 22.6165 20.2831 21.8958V11.4131C20.2831 10.6924 20.8746 10.1027 21.5974 10.1027C22.3203 10.1027 22.9117 10.6924 22.9117 11.4131V21.8958C22.9117 22.6165 22.3203 23.2062 21.5974 23.2062Z",
    fill: "url(#paint0_linear_3251_11892)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3251_11892",
    x1: 16.3403,
    y1: 4.86133,
    x2: 16.3403,
    y2: 28.4475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF45A3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3251_11892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.5429,
    height: 31.4483,
    fill: "white",
    transform: "translate(0.574219 0.929688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplistSingleImg);
export default __webpack_public_path__ + "static/media/applist-single-img.5f54d830f61d20918ba90ec2e2d29102.svg";
export { ForwardRef as ReactComponent };